import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipSalesSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ActiveMembersStats from "./smartComponents/activeMembersStats";
import ActiveMembersStatsPrevious from "./smartComponents/activeMembersStatsPrevious";
import CancelledMembersStats from "./smartComponents/cancelledMembersStats";
import CancelledMembersStatsPrevious from "./smartComponents/cancelledMembersStatsPrevious";
import NewMembersStats from "./smartComponents/newMembersStats";
import NewMembersStatsPrevious from "./smartComponents/newMembersStatsPrevious";
import FrozenMembersStats from "./smartComponents/frozenMembersStats";
import FrozenMembersStatsPrevious from "./smartComponents/frozenMembersStatsPrevious";
import AttritionRateStats from "./smartComponents/attritionRateStats";
import NetUnitMtdStats from "./smartComponents/netUnitMtdStats";
import NetUnitMtdStatsPrevious from "./smartComponents/netUnitMtdStatsPrevious";
import MembershipDetailsChart from "./smartComponents/membershipDetailsChart";
import LearnMore from "../../../components/learnMore/learnMore";
import { useFetchData } from "../hooks/dataFetchingHooks";

const MembershipDetailsModule = (props) => {
  useFetchData({
    moduleName: "membershipSales",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.membershipSales.isLoading);
  const displayFrozen = useSelector((state) => state.membershipSales.statistics.displayFrozen);

  const renderContent = () => {
    return (
      <div>
        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <ActiveMembersStats />
            </span>
            <span className="width-50">
              <ActiveMembersStatsPrevious />
            </span>
          </div>

          <div className="section-group">
            <span className="width-50">
              <CancelledMembersStats />
            </span>
            <span className="width-50">
              <CancelledMembersStatsPrevious />
            </span>
          </div>
        </div>

        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <NewMembersStats />
            </span>
            <span className="width-50">
              <NewMembersStatsPrevious />
            </span>
          </div>

          <div className="section-group">
            {displayFrozen === true ? (
              <>
                <span className="width-50">
                  <FrozenMembersStats />
                </span>
                <span className="width-50">
                  <FrozenMembersStatsPrevious />
                </span>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="section-group-container">
          <div className="section-group">
            <span className="width-50">
              <NetUnitMtdStats />
            </span>
            <span className="width-50">
              <NetUnitMtdStatsPrevious />
            </span>
          </div>

          <div className="section-group">
            <span className="width-50">
              <AttritionRateStats />
            </span>
          </div>
        </div>

        <div className="section-group" style={{ height: "350px", width: "100%" }}>
          <MembershipDetailsChart />
        </div>
      </div>
    );
  };

  return (
    <SectionToggle
      title="Membership Sales"
      learnMore={<LearnMore {...props.learnMore} html />}
      customClass={`membershipsalesWidget ${isLoading ? "" : "active"}`}
      height={800}
      isLoading={isLoading}
      content={renderContent()}
    />
  );
};

export default MembershipDetailsModule;
